import { yupResolver } from '@hookform/resolvers/yup';
import { AxiosError } from 'axios';
import { ChangeEvent, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import StickButtonsBloc from '../../common/StickButtonsBloc';
import { APP_RETIREMENT_URLS, APP_URLS, ERROR_MESSAGES, MAX_SMALL_MOBILE_WIDTH } from '../../../const/AppConst';
import useAppState from '../../../context/AppContext';
import { environementValues, IApiErrors, IdentityType } from '../../../context/model';
import MgpMessage from '../../../elements/MgpMessage/MgpMessage';
import LoaderModal from '../../../modals/common/LoaderModal';
import { deleteDocument, downloadUploadedDocument, uploadIdentityDocument } from "../../../services/CustomerApiService";
import { getCompressFile, getFilename, isAcceptedFileSize, isMobile, isValidFileSize, isValidFileType } from '../../../utils/utils';
import UploadFilePreviewModal from '../../../modals/common/UploadFilePreviewModal';
import { isPropositionInLock } from '../../../utils/dataUtils';
import QrCodeModal from '../../../modals/common/QrCodeModal';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import ListOfFileUploaded from '../../../components/common/ListOfFileUploaded';
import MgpInputFileUpload from '../../../elements/MgpInputFileUpload/MgpInputFileUpload';
import UploadFromPhoneButton from '../../../components/common/UploadFromPhoneButton';
import UploadDocumentButton from '../../../components/common/UploadDocumentButton';
import UploadTwoSidedMobileComponent from '../../../components/common/UploadTwoSidedMobileComponent';
import UploadTwoSidedDesktopComponent from '../../../components/common/UploadTwoSidedDesktopComponent';
 
 
type InfoPersoStep6FormData = { 
  file: File | null;
}
 
 
export default function REInfoIdentityDocBloc() {
 
  const {
    state: { proposition, jwtToken, identityDoc, showModal, additionalData },
    dispatch,
  } = useAppState();
 
  const validationSchema = Yup.object().shape({});

  const {
    register,
    handleSubmit, getValues, setValue, 
    formState: { errors, isSubmitting },
  } = useForm<InfoPersoStep6FormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      file: null
    },
    resolver: yupResolver(validationSchema),
  });

  const [identityType, setIdentityType] = useState<IdentityType | null >(null);
  const [errorFileTypeMsg, setErrorFileTypeMsg] = useState<boolean | null>();
  const [errorFileSizeMsg, setErrorFileSizeMsg] = useState<boolean | null>();
  const [errorMsg, setErrorMsg] = useState<string | null>();
  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [showQrModal, setShowQrModal] = useState<boolean>(false);
  const [showUploadButton, setShowUploadButton] = useState<boolean>(false);
  const [showUploadMultiple, setShowUploadMultiple] = useState<boolean>(false);
  const [hasMultipleFile, setHasMulipleFile] = useState<boolean>(false);
  const navigate = useNavigate();

  const {width} = useWindowDimensions();
  const isDesktop = width > MAX_SMALL_MOBILE_WIDTH;

  const showQrCodeModal = () => {
    setShowQrModal(true);
  }
  const closeQrModal = () => {
    setShowQrModal(false);
  }

 
  const closeModal = () => {
    setModalIsOpen(false);
    dispatch({type: 'SHOW_MODAL', showModal: false});
  };
  const handleChange = (event: any, value: IdentityType) => {
    event.preventDefault();
    setIdentityType(value);
  }
 
  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    try {
      const uploadedfile = event.target.files ? event.target.files[0] : null;
   
      if (uploadedfile) {
        if(!isValidFileType(uploadedfile)) {
          setErrorFileTypeMsg(true);
        } else if(!isValidFileSize) {
          setErrorFileSizeMsg(true)
        } else if (!isAcceptedFileSize(uploadedfile)) {
          try {
            const token = jwtToken!.accessToken;
            const newFile = await getCompressFile(token, uploadedfile);
            setValue('file', newFile);
            setShowUploadButton(true);
            setModalIsOpen(true);
            dispatch({type: 'SHOW_MODAL', showModal: true});    
          } catch(e) {
            setErrorMsg("Suite à un incident technique, nous ne pouvons pas uploader votre fichier. Veuillez sélectionner à nouveau.");
          } 
        } else {
          setValue('file', uploadedfile);
          setModalIsOpen(true);
          setShowUploadButton(true);
          dispatch({type: 'SHOW_MODAL', showModal: true});
        }
      } 
    } catch (error) {
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
  };
  
 
  const onSubmit = async () => {
    setErrorMsg(null);
    try {
      // const isRequired = process.env.REACT_APP_ENV_MODE === environementValues.PROD || process.env.REACT_APP_ENV_MODE === environementValues.RECETTE;
      const isRequired = proposition?.configuration?.requireIdentityDocument;
      if (!identityDoc && isRequired) {
        setErrorMsg("Votre justificatif d'identité est obligatoire.")
      } else {
        setSuccess(true);
        const nextUrl = APP_RETIREMENT_URLS.infoRetirementDocPage
   
        dispatch({type: 'NEXT_INFO_STEP', path: nextUrl});
        navigate({
          pathname: nextUrl,
          search: `?id=${proposition!.propositionId}`,
        });
      }
 
    } catch (error) {
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
  }
 
  const documentSubmit = async (fileToUpload: File, backSideFile: File | null) => {
    setErrorMsg(null);
    setErrorFileTypeMsg(false);
    setErrorFileSizeMsg(false);
    setLoading(true);

    try {
      const token = jwtToken!.accessToken;
      const res =  await uploadIdentityDocument(token, proposition!.propositionId, fileToUpload, backSideFile, identityType, true);
      dispatch({type: 'UPLOAD_IDENTITY', identityDoc: {id: res.data.id, name: res.data.name, fileName: res.data.fileName}});
     
      setModalIsOpen(false);
      dispatch({type: 'SHOW_MODAL', showModal: false});
      setLoading(false);
      setShowUploadMultiple(false);
      
    } catch (error) {
      setLoading(false);
      const err = error as AxiosError;
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        if (errorData.code === "DOCUMENT_TYPE_ERROR") {
          setErrorMsg("Le document fourni ne correspond pas au type sélectionné.");
        } else if (errorData.code === "DOC_VALIDITY_ERROR") {
          setErrorMsg("Votre pièce d'identité n'a pu être validée par notre système. Veuillez suivre les recommandations suivantes :\n- Pièce entière lisible et bien cadrée.\n- Pas de taches ou de reflets masquant les données.")
        } else if (errorData.code === "OCR_BIRTHDATE_ERROR") {
          setErrorMsg("Les données du souscripteur ne correspondent pas à la pièce fournie.")
        } else if (errorData.code === "MRZ_CONFORMITY_ERROR") {
          setErrorMsg("Votre pièce d'identité n'a pu être validée par notre système. Veuillez suivre les recommandations suivantes :\n- Pièce entière lisible et bien cadrée.\n- Pas de taches ou de reflets masquant les données.")
        } else if (errorData.code === "MRZ_OCR_CONSISTENCY_ERROR") {
          setErrorMsg("Votre pièce d'identité n'a pu être validée par notre système. Veuillez suivre les recommandations suivantes :\n- Pièce entière lisible et bien cadrée.\n- Pas de taches ou de reflets masquant les données.")
        } else {
          setErrorMsg("Une erreur technique est survenue ");
        }  
      } else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
  }

  const onEventMessage = (message: any, type: string) => {
    if(type === 'upload') {
      dispatch({type: 'UPLOAD_IDENTITY', identityDoc: {id: message.id, name: message.name, fileName: message.fileName}});
      setLoading(false);
      setShowQrModal(false);
      setShowUploadMultiple(false);
    }
  }


  const onPreviousAction = async () => {
    const hasBeneficiaryStep = additionalData?.hasChild || additionalData?.hasPartner;
    const url = hasBeneficiaryStep 
                ? APP_RETIREMENT_URLS.infoBeneficiaryPage 
                : APP_RETIREMENT_URLS.infoAttestationROPage;
   
    dispatch({type: 'BACK_INFO_STEP', path: url});
    navigate({
        pathname: url,
        search: `?id=${proposition!.propositionId}`,
    });         
  }

  const downloadDocument = async (documentId: string) => {
    try {
      const token = jwtToken!.accessToken;
      const res = await downloadUploadedDocument(token, proposition!.propositionId, documentId);
      const filename = getFilename(res.headers)
      const file = new File([res.data], filename)
      setValue('file', file);
      setModalIsOpen(true);
      setShowUploadButton(false);
      dispatch({type: 'SHOW_MODAL', showModal: true});
    } catch (error) {
      setLoading(false);

      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else if (err.response && err.response.status === 404) {
        setErrorMsg(ERROR_MESSAGES.documentNotFound);
      }else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
  }

  const onDeleteDocument = async (documentId: string) => {
    try {
      const token = jwtToken!.accessToken;
      await deleteDocument(token, proposition!.propositionId, documentId);
      
      dispatch({type: 'UPLOAD_IDENTITY', identityDoc: null});
      setIdentityType(null);
      setErrorMsg(null);
    } catch (error) {
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else if (err.response && err.response.status === 404) {
        dispatch({type: 'UPLOAD_IDENTITY', identityDoc: null});
        setIdentityType(null);
        setErrorMsg(null);
      } else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
    
  }

  const closeModalUploadMultiple = () => {
    setShowUploadMultiple(false);
    setErrorMsg('');
  }

  const handleSwitchUploadFromPhone = () => {
    setErrorMsg('');
    setShowUploadMultiple(false);
    setShowQrModal(true);
  }

  const handleSwitchUploadFromComputer = () => {
    setErrorMsg('');
    setShowQrModal(false);
    if (identityType === IdentityType.CNI || identityType === IdentityType.CST) {
      setShowUploadMultiple(true);
    }
  }

  let identityLabel : string;

  if (identityType === IdentityType.CNI) {
    identityLabel = "Ma carte d'identité :";
  } else if (identityType === IdentityType.PASSPORT) {
    identityLabel = "Mon passeport :";
  } else {
    identityLabel = "Ma carte de séjour :";
  }
 
  return (
      <>
      {!success && <form style={{width: '100%'}}>
        <div className='form-row page-content'>
          <div className='col-flex-4 bg-blanc shadow-noir p-lg m-y-xs'>
            <h2 className="card-title bleu">Mon justificatif d'identité&nbsp;:</h2>
            <div>
              { errorMsg && !showUploadMultiple && <p className='bg-fushia blanc p-md mt-md'>{errorMsg}</p> }
              { hasMultipleFile && <MgpMessage type='info' message='Vos fichiers ont bien été fusionnés et téléchargés' hasCloseBtn={true} /> }
            </div>
    
            {
              identityDoc &&
              <div className='form-row'>
                <div className='form-group mw-100'>
                  <ListOfFileUploaded 
                    fileName={identityDoc.name}
                    onDeleteDocument={() => onDeleteDocument(identityDoc.id)}
                    onDownloadDocument={() => downloadDocument(identityDoc.id)}
                  />
                </div>
              </div>
            }

            {
              !identityDoc &&  !showModal && 
                <div>
                  <div className='form-row'>
                    <div className='form-group mw-75'>
                      {errorFileTypeMsg && <p className='text blanc p-sm bg-fushia'>{ERROR_MESSAGES.fileTypeMsg}</p> }
                      {errorFileSizeMsg && <p className='text blanc p-sm bg-fushia'>{ERROR_MESSAGES.fileSizeMsg}</p> }
                    </div>
                  </div>   

                  {
                    !identityType ? 
                    <div>
                      <div className="form-row">
                        <div className="form-group mw-50">
                          <button className={`p-y-sm cta-bleu inverse mw-100`} onClick={(e) => handleChange(e, IdentityType.CNI)} style={{width: "100%"}}>Carte d'identité</button>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="form-group mw-50">
                          <button className={`cta-bleu inverse p-y-sm mw-100`} onClick={(e) => handleChange(e, IdentityType.PASSPORT)} style={{width: "100%"}}>Passeport</button>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className="form-group mw-50">
                          <button className={`cta-bleu inverse p-y-sm`} onClick={(e) => handleChange(e, IdentityType.CST)} style={{width: "100%"}}>Carte de séjour</button>
                        </div>
                      </div>
                    </div>
                    :
                    <p className='text fw-medium'>
                      {identityLabel}
                    </p>
                  }
           
           
                  {
                    identityType && 
                      <div className="form-row">
                        <div className='form-group mw-45'>
                          {
                            identityType === IdentityType.PASSPORT ?
                            <MgpInputFileUpload
                            id="file"
                            onChange={(e) => handleFileChange(e)}
                            register={register} 
                            errors={errors}
                            /> 
                            :
                            <UploadDocumentButton onClick={() =>  {
                              setShowUploadMultiple(true);
                              setErrorMsg('');
                            }}/>
                          }
                        
                        </div>
                        {
                          isDesktop && <div className="form-group mw-5 ta-center"><p className='fz-lg mt-xl'>ou</p></div>
                        }
                        {isDesktop && 
                        <div className='form-group mw-45'>
                          <UploadFromPhoneButton onClick={() => showQrCodeModal()}/> 
                        </div>}       
                      </div>
                  }

                  {
                    identityType && <p className='text mt-md' onClick={() => {
                      setIdentityType(null)  
                    }}>Changez d'avis? <span className='link'>Cliquez ici</span></p>
                  }
 
                </div>
              }
            </div>

          <div className='col-flex-4 bg-blanc shadow-noir p-lg m-y-xs'>
            { (!identityType || identityType === IdentityType.CNI || identityType === IdentityType.CST ) && <div className='ta-center mb-lg'>
              <h2 className="card-title bleu">{ identityType === IdentityType.CNI ? "Carte d'identité*" : identityType === IdentityType.CST ? "Carte de séjour*" : "Carte d'identité / Carte de séjour*"} </h2>
              <div className='grid-flex'>
                <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto_Carte_R.svg"} width="40%" height="40%" style={{boxShadow: "none"}} alt='' />
                <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto_Carte_V.svg"} width="40%" height="40%" style={{boxShadow: "none"}} alt='' />
              </div>
              <p className='text pb-md'>(recto / verso - ancien et nouveau format)</p>
            </div>}
              
            { (!identityType || identityType === IdentityType.PASSPORT ) && <div className='ta-center'>
              <h2 className="card-title bleu">Passeport*</h2>
              <div className='grid-flex'>
                <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto_Passport.svg"} width="40%" height="40%" style={{boxShadow: "none"}} alt='' />
              </div>
              <p className='text'>(*) L'image doit être nette et de bonne qualité</p>
            </div>}
          </div>

        </div>

        {modalIsOpen && getValues('file')&&<UploadFilePreviewModal file={getValues('file') as File} onUploadAction={() => documentSubmit(getValues('file') as File, null)} isOpen={modalIsOpen} onCloseModal={closeModal} showButton={showUploadButton}/>}

        {
          !showModal&& !showUploadMultiple && <StickButtonsBloc disabledPreviousButton={proposition && isPropositionInLock(proposition) ? true : false} showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={onSubmit}/>
        }
 
        {showQrModal && identityType && <QrCodeModal isOpen={showQrModal} onCloseModal={closeQrModal} docCode={identityType} onEventMessage={onEventMessage} handleSwitchUploadFromComputer={handleSwitchUploadFromComputer}/>}

        {showUploadMultiple && identityType && isMobile() && <UploadTwoSidedMobileComponent isOpen={showUploadMultiple} onCloseModal={closeModalUploadMultiple} docType={identityType} onUploadAction={documentSubmit} uploadError={errorMsg ?? ''} /> }
        {showUploadMultiple && identityType && !isMobile() && <UploadTwoSidedDesktopComponent isOpen={showUploadMultiple} onCloseModal={closeModalUploadMultiple} docType={identityType} onUploadAction={documentSubmit} handleSwitchUploadFromPhone={handleSwitchUploadFromPhone} uploadError={errorMsg ?? ''}/>}

        {(isSubmitting || loading) && <LoaderModal hasMessage={false}/>}
      </form>}
      </>
  )
}
